// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import moment from 'moment';
import { BookitupNotification } from '../../../../Types/LogT';
import { RoutingS } from '../../../../Service/RoutingS';
import LinkText from '../../../../Atoms/LinkText';

const ContractWithdrawn: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { eventId, eventDate, personDescription, value } = notification;

  return (
    <Text>
      <Text span weight="bolder">
        {personDescription}
      </Text>
      {'  '}ist vom Vertrag
      {value && (
        <Text span weight="bolder">
          {` ${value}`}
        </Text>
      )}
      {eventDate && (
        <>
          {'  '}für das Event am{'  '}
          <LinkText
            span
            weight="bolder"
            disabled={!eventId}
            onClick={() => eventId && RoutingS.openInNewTab(`/events/${eventId}/details`)}
          >
            {moment(eventDate).format('LL')}
          </LinkText>
        </>
      )}
      {'  '}zurückgetreten.
    </Text>
  );
};

export default ContractWithdrawn;
